(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["local-pickup-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const pickupCode = 'CANBERRAPICKUP';
    let pendingPickupCode = false;

    const getDialog = () => document.getElementById('LocalPickupDialog');

    const openDialog = () => {
      const dialog = getDialog();
      if (!(dialog instanceof HTMLDialogElement) || dialog.open) return;
      dialog.showModal();
    };

    const closeDialog = (event) => {
      const target = event.target;
      if (!(target instanceof Element) || !target.closest('[data-local-pickup-close]')) return;
      const dialog = getDialog();
      if (dialog instanceof HTMLDialogElement) dialog.close();
    };

    const detectPickupSubmission = (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.closest('cart-discount-component')) return;
      const input = form.querySelector('input[name="discount"]');
      pendingPickupCode = input instanceof HTMLInputElement && input.value.trim().toUpperCase() === pickupCode;
    };

    const detectAppliedPickup = () => {
      if (!pendingPickupCode) return;
      const shippingMessage = document.querySelector('[ref="cartDiscountErrorShipping"]:not(.hidden)');
      if (!shippingMessage) return;
      shippingMessage.closest('.cart-discount__error')?.classList.add('hidden');
      pendingPickupCode = false;
      openDialog();
    };

    document.addEventListener('submit', detectPickupSubmission, true);
    document.addEventListener('click', closeDialog);

    const observer = new MutationObserver(detectAppliedPickup);
    observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });

    const parameters = new URLSearchParams(window.location.search);
    if (parameters.get('local_pickup') === '1') {
      window.requestAnimationFrame(openDialog);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["restock-notify"] && !Shopify.designMode) return;
  try {
    class RestockNotify extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      this.status = this.querySelector('[role="status"]');
      this.openButton = this.querySelector('.restock-notify__open');
      this.closeButton = this.querySelector('.restock-notify__close');
      this.section = this.closest('.shopify-section, dialog');

      this.openButton?.addEventListener('click', this.openDialog);
      this.closeButton?.addEventListener('click', this.closeDialog);
      this.dialog?.addEventListener('click', this.closeOnBackdrop);
      this.form?.addEventListener('submit', this.submit);
      this.section?.addEventListener('variant:update', this.updateVariant);
    }

    disconnectedCallback() {
      this.openButton?.removeEventListener('click', this.openDialog);
      this.closeButton?.removeEventListener('click', this.closeDialog);
      this.dialog?.removeEventListener('click', this.closeOnBackdrop);
      this.form?.removeEventListener('submit', this.submit);
      this.section?.removeEventListener('variant:update', this.updateVariant);
    }

    openDialog = () => {
      this.status.textContent = '';
      this.status.removeAttribute('data-state');
      this.dialog?.showModal();
      this.form?.elements.email?.focus();
    };

    closeDialog = () => this.dialog?.close();

    closeOnBackdrop = (event) => {
      if (event.target === this.dialog) this.closeDialog();
    };

    updateVariant = (event) => {
      const variant = event.detail?.resource;
      if (!variant) return;

      this.dataset.variantId = String(variant.id || '');
      this.dataset.variantTitle = variant.title || '';
      this.hidden = Boolean(variant.available) || !this.dataset.endpoint;

      const variantLabel = this.querySelector('.restock-notify__item span');
      if (variantLabel) {
        variantLabel.textContent = variant.title || '';
        variantLabel.hidden = !variant.title || variant.title === 'Default Title';
      }
    };

    submit = async (event) => {
      event.preventDefault();
      if (!this.form?.reportValidity()) return;

      const button = this.form.querySelector('button[type="submit"]');
      const originalLabel = button.dataset.label;
      button.disabled = true;
      button.textContent = this.dataset.submittingLabel || 'Saving…';
      this.status.textContent = '';

      const formData = new FormData(this.form);
      const payload = {
        email: formData.get('email'),
        website: formData.get('website'),
        variantId: this.dataset.variantId,
        variantTitle: this.dataset.variantTitle,
        productHandle: this.dataset.productHandle,
        productTitle: this.dataset.productTitle,
        productUrl: this.dataset.productUrl,
      };

      try {
        const response = await fetch(this.dataset.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        const result = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(result.error || 'Request failed');

        this.status.textContent = result.message || this.dataset.successMessage;
        this.status.dataset.state = 'success';
        this.form.reset();
      } catch (_error) {
        this.status.textContent = this.dataset.errorMessage;
        this.status.dataset.state = 'error';
      } finally {
        button.disabled = false;
        button.textContent = originalLabel;
      }
    };
  }

  if (!customElements.get('restock-notify')) {
    customElements.define('restock-notify', RestockNotify);
  }
  } catch(e) { console.error(e); }
})();

})();
